<template>
    <div class="ManagementRole" style="padding:30px;
     background: #FFFFFF;
   border-radius: 10px;">
        <h4>{{$t('i18n_role_management')}}</h4>
        <el-button type="primary" style="margin: 20px"  @click="addRole()">{{$t('i18n_create_new_role')}}</el-button>
        <el-table border
            :data="tableData" max-height="500px"
            tooltip-effect="dark" :header-cell-style="{background:'#F3F3F3'}"
            ref="multipleTable"
            style="width: 97%;margin-left:17px;" >
            <el-table-column type="index" :label="$t('i18n_Serial_number')" width="60px" min-width="8%"></el-table-column>
            <el-table-column prop="cnName" :label="$t('i18n_role_name_in_chinese')" min-width="10%"></el-table-column>
            <el-table-column prop="enName" :label="$t('i18n_role_name_in_English')" min-width="10%"></el-table-column>
            <el-table-column prop="statuss" :label="$t('i18n_Roles')" min-width="10%"></el-table-column>
            <el-table-column prop="remark" :label="$t('i18n_remark')" min-width="10%"></el-table-column>
            <el-table-column prop="createTime" :label="$t('i18n_creation_time')" min-width="10%"></el-table-column>
            <el-table-column prop="operation" :label="$t('i18n_Operation')" min-width="10%">
              <template slot-scope="scope">
                <el-button @click="amend(scope)" type="text" size="small">{{$t('i18n_edit')}}</el-button>
                <el-button @click="gobalbuyer(scope)" type="text" size="small">{{$t('i18n_View_permissions')}}</el-button>
                <el-button @click="PermisAssign(scope)" type="text" size="small">{{$t('i18n_Permission_assignment')}}</el-button>
              </template>
            </el-table-column>
        </el-table>
        <div class="panelBox" v-show="panelBox">
            <div class="panel">
                <i class="el-icon-circle-close close" @click="closePanel()"></i>
                <h4 v-if="addPanel">{{$t('i18n_create_new_role')}}</h4>
                <h4 v-else>{{$t('i18n_Modify_Role')}}</h4>
                <el-form ref="roleForm" :label-position="labelPosition" :rules="rules" :model="roleForm"
                label-width="80px" size="mini" hide-required-asterisk>
                    <el-form-item :label="$t('i18n_role_name_in_chinese')" prop="cnName">
                        <el-input v-model="roleForm.cnName" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_role_name_in_English')" prop="enName">
                        <el-input v-model="roleForm.enName" :placeholder="$t('i18n_please_enter')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_Status')" prop="status">
                        <el-select v-model="roleForm.status" :placeholder="addPls('i18n_Status', 'select')">
                            <el-option :label="$t('i18n_Enable')" value="1"></el-option>
                            <el-option :label="$t('i18n_Disable')" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('i18n_remark')" prop="remark" style="min-height: 80px;">
                        <el-input type="textarea" v-model="roleForm.remark" style="min-height: 80px;"></el-input>
                    </el-form-item>
                    <el-row v-if="addPanel">
                        <el-button size="small" @click="goonadd('roleForm')">{{$t('i18n_Confirm_continue')}}</el-button>
                        <el-button size="small" @click="addRoleend('roleForm')">{{$t('i18n_Confirm')}}</el-button>
                    </el-row>
                    <el-row v-else>
                        <el-button size="small" @click="amendend('roleForm')">{{$t('i18n_confirm_edit')}}</el-button>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import { addPls } from '@/utils/placeholderI18n'
export default {
    name:"ManagementRole",
    data() {
        return {
            labelPosition: 'left',
            tableData:[
                {
                    // cnName:"",
                    // enName:"",
                    // status:"",
                    // remark:"",
                    // createTime:"",
                    // createUser:"",//创建人
                    // id:"",//主键
                }
            ],
            roleForm:{
                cnName:"",
                enName:"",
                id:'',
                status:"1",
                remark:"",
            },
            rules: {
                cnName: [
                    { required: true, message: this.addPls('i18n_role_name_in_chinese', 'input'), trigger: 'blur' }
                ],
                enName: [
                    { required: true, message: this.addPls('i18n_role_name_in_English', 'input'), trigger: 'blur' }
                ],
                status: [
                    { required: true, message: this.addPls('i18n_Status', 'select'), trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: this.addPls('i18n_remark', 'input'), trigger: 'blur' }
                ]
            },
            panelBox:false,//弹框显示
            addPanel:true,//控制添加修改
        }
    },
    watch: {},
    methods: {
        addRole() {//新建角色
            this.panelBox = true;
            this.addPanel = true;
            this.roleForm = {
                cnName:"",
                enName:"",
                id:null,
                status:"1",
                remark:"",
            }
        },
        amend(data){//table修改
            // console.log(data);
            this.panelBox = true;
            this.addPanel = false;
            this.roleForm.cnName = data.row.cnName;
            this.roleForm.enName = data.row.enName;
            this.roleForm.status = data.row.status+"";
            this.roleForm.remark = data.row.remark;
            this.roleForm.id = data.row.id;
        },
        gobalbuyer(data){//table查看权限
            // console.log(data.row.id);
            this.$router.push({name: 'PermissionAssignment', query: {'roleid': data.row.id,'cnName':data.row.cnName,'enName':data.row.enName,'type':"查看权限"}});
        },
        PermisAssign(data){//table权限分配
            // console.log(data);
            this.$router.push({name: 'PermissionAssignment', query: {'roleid': data.row.id,'cnName':data.row.cnName,'enName':data.row.enName,'type':"权限分配"}});
        },
        closePanel(){//关闭弹框
            this.panelBox = false;
        },
        goonadd(roleForm){//确认新建并继续新建
            this.$refs[roleForm].validate((valid) => {
                if (valid) {
                    this.addRolerequest();
                    this.panelBox = true;
                    this.$refs[roleForm].resetFields();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        addRoleend(roleForm){//确认新建
            this.$refs[roleForm].validate((valid) => {
                if (valid) {
                    this.addRolerequest();
                    this.closePanel();
                    // this.Notifications()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        amendend(roleForm){//确认修改
         this.$refs[roleForm].validate((valid) => {
                if (valid) {
                    this.addRolerequest();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            // this.closePanel();
            // this.addRolerequest();
        },
        Notifications(data){//消息提示
            this.$message({
                message: data
            });
        },
        getRoleAlldata(){//角色所有的数据
            let params = {
                "roleName": "",
                "status":""
            };
            let that = this;
            that.axios.get(
                "/authorization/getSubAccountRoleList",
                {params}
            )
            .then((response)=> {
                console.log(response.data.datas);//.data.datas
                that.tableData = response.data.datas;
                for(var i=0;i<that.tableData.length;i++){
                    if(that.tableData[i].status == 0){
                        that.tableData[i].statuss = this.$t("i18n_Disable");
                    }else if(that.tableData[i].status == 1){
                        that.tableData[i].statuss = this.$t("i18n_Enable");
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        addRolerequest(){//新建角色/修改角色
            let data= {
                "cnName": this.roleForm.cnName,
                "enName": this.roleForm.enName,
                "id": this.roleForm.id,
                "remark": this.roleForm.remark,
                "status": this.roleForm.status
            };
            // console.log(data)
            let that = this;
            that.axios.post(
                "/authorization/saveOrUpdateRoleInfo",
                data
            )
            .then((response)=> {
                that.Notifications(response.data.message);
                if(response.data.message == "成功"){//
                    this.getRoleAlldata();
                     this.panelBox = false;
                    this.$refs[roleForm].resetFields();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        addPls,
    },
    created () {},
    mounted () {
        this.getRoleAlldata();
    },
}
</script>
<style lang="scss" scoped >
.ManagementRole{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: #dbdada 0px 0px 20px 0px;

}
.ManagementRole h4{
    // width: 100px;
    // height: 23px;
    margin-top: 10px;
    margin-left: 17px;
    font-size: 24px;
    font-family: "PingFang SC";
    font-weight: bold;
    color: #333333;
}
.ManagementRole .addRole{
    display: block;
    width: 150px;
    height: 40px;
    margin-top: 36px;
    margin-bottom: 21px;
    margin-left: 17px;
    font-size: 16px;
    background: #FFFFFF;
    color: $d2d-color-primary;
    border: 1px solid $d2d-color-primary;
    border-radius: 5px;
}
/* ---------------------弹框---------------------- */
.ManagementRole .panelBox{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 2;
}
.ManagementRole .panelBox .panel{
    position: absolute;
    top: calc(50% - 250px);
    left: calc(50% - 260px);
    width: 520px;
    height: 500px;
    background: #fff;
    border-radius: 10px;
}
.ManagementRole .panelBox .panel h4{
    margin-top: 25px;
    margin-left: 27px;
}
.ManagementRole .panelBox .panel i.close{
    position: absolute;
    top: 25px;
    right: 20px;
    font-size: 24px;
}
.ManagementRole .panelBox .panel i:hover{
    color: #409EFF;
}
.ManagementRole .panelBox .el-form .el-form-item--mini.el-form-item, .ManagementRole .panelBox .el-form-item--small.el-form-item{
    width: 86%;
    margin-left: 5%;
    margin-top: 33px;
    margin-bottom: 25px;
}
.ManagementRole .panelBox .el-textarea__inner{
    min-height: 80px!important;
}
.ManagementRole .panelBox .el-input--mini .el-input__inner{
    height: 34px;
    line-height: 34px;
}
.ManagementRole .panelBox .el-button--small, .ManagementRole .panelBox .el-button--small.is-round{
    width: 173px;
    height: 40px;
    margin-right: 8px;
    color: $d2d-color-primary;
    border: 1px solid $d2d-color-primary;
    border-radius: 5px;
}
.ManagementRole .panelBox .el-row{
    margin-left: 106px;
}
.ManagementRole .panelBox .el-button--small:hover, 
.ManagementRole .panelBox .el-button--small.is-round:hover,
.ManagementRole .addRole:hover{
    background: $d2d-color-primary;
    color: #fff;
}
/* -------------------element -------------------- */
.ManagementRole .el-table td, .el-table th{
    text-align: center;
}
/* table 滚动条 */
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar{
    width: 3px;
}
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar-thumb{
    border-radius: 2px;
    height: 50px;
    background: #409EFF;
}
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/ManagementRole.vue